import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Typography } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import {
  StyledCard,
  TimeSeriesScrollContainer,
  TimeSeriesItem,
  TimeSeriesHeader,
  TimeSeriesPeriod,
  TimeSeriesAmount,
  TimeSeriesOrders,
  StyledProgress,
  AverageOrderText,
  EmptyStateText,
} from './Styles';
import { addCommasInPrices } from './constants';
import { TimeSeriesSectionProps } from './types';
import { EMPTY_STATE_MESSAGES } from './constants';

const { Text, Title } = Typography;

const TimeSeriesSection: React.FC<TimeSeriesSectionProps> = ({ reportData }) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  if (!reportData?.timeSeriesData || reportData.timeSeriesData.length === 0) {
    return (
      <ThemeProvider theme={theme}>
        <StyledCard
          title={<Title level={4} style={{ margin: 0 }}>Time Series Data</Title>}
        >
          <EmptyStateText>{EMPTY_STATE_MESSAGES.TIME_SERIES}</EmptyStateText>
        </StyledCard>
      </ThemeProvider>
    );
  }

  const timeSeriesData = reportData.timeSeriesData;
  const maxAmount = Math.max(...timeSeriesData.map((item: any) => item.amount));

  return (
    <ThemeProvider theme={theme}>
      <StyledCard
        title={
          <div>
            <Title level={4} style={{ margin: 0, marginBottom: 4 }}>
              Daily Performance
            </Title>
            <Text type="secondary" style={{ fontSize: 14 }}>
              Sales and order count for each day in the selected period
            </Text>
          </div>
        }
      >
        <TimeSeriesScrollContainer>
          {timeSeriesData.map((item: any, index: number) => {
            const percentage = maxAmount > 0 ? (item.amount / maxAmount) * 100 : 0;

            return (
              <TimeSeriesItem key={index}>
                <TimeSeriesHeader>
                  <TimeSeriesPeriod>{item.period}</TimeSeriesPeriod>
                  <TimeSeriesAmount>
                    <Text strong>${addCommasInPrices(item.amount)}</Text>
                    <TimeSeriesOrders>{item.count} orders</TimeSeriesOrders>
                  </TimeSeriesAmount>
                </TimeSeriesHeader>
                <StyledProgress
                  percent={percentage}
                  showInfo={false}
                  strokeColor={{
                    '0%': '#3b82f6',
                    '100%': '#2563eb',
                  }}
                />
                <AverageOrderText>
                  Avg Order: ${addCommasInPrices(item.averageOrderValue)}
                </AverageOrderText>
              </TimeSeriesItem>
            );
          })}
        </TimeSeriesScrollContainer>
      </StyledCard>
    </ThemeProvider>
  );
};

export default TimeSeriesSection;
